 // src/subscreens/mechanicadmin/layout/MechanicAdminLayout.jsx

import React, { useState, useEffect, useContext } from "react";
import { Row, Col } from "react-bootstrap";
import MechanicAdminSidebar from "../../components/mechanic/mechanicsidebar/MechanicSideBar.js";
import MechanicTopNavbar from "../../components/mechanic/mechanictopbar/MechanicTopBar.js";
import "../../assets/css/mechanic/mechaniclayout/MechanicLayout.css";
import AppContext from "../../context/AppContext.js";

const MechanicAdminLayout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const {setAuthToken} = useContext(AppContext);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setIsSidebarOpen(false);
      }
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const closeSidebar = () => setIsSidebarOpen(false);

  return (
    <div className="mechanic-admin-master-layout">
      <Row className="mechanic-g-0">
        {/* Desktop Sidebar */}
        <Col
          lg={3}
          md={4}
          className={`mechanic-sidebar-col ${isMobile ? "d-none" : ""}`}
        >
          <MechanicAdminSidebar isOpen={false} onClose={closeSidebar} />
        </Col>

        {/* Mobile Sidebar - overlay */}
        {isMobile && (
          <MechanicAdminSidebar
            isOpen={isSidebarOpen}
            onClose={closeSidebar}
          />
        )}

        {/* Main Content */}
        <Col lg={9} md={8} sm={12} className="mechanic-content-col">
          <MechanicTopNavbar
            onToggleSidebar={toggleSidebar}
            isSidebarOpen={isSidebarOpen}
          />
          <div className="mechanic-admin-content-wrapper">{children}</div>
        </Col>
      </Row>
    </div>
  );
};

export default MechanicAdminLayout;